import Vue from "vue";
import VueRouter from "vue-router";
import { showMessage } from "@/utils/message";
Vue.use(VueRouter);
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  const arrPath = ['/', '/?moduleTitle=首页','/login','/register', '/getPassword']
  let path = to.path ? to.path : to;
  if(!arrPath.includes(path)) {
    if(path === '/editPassword' && !sessionStorage.getItem('X-Access-Token')) {
      showMessage('请先登录再进行修改密码操作','info');
      return;
    }
    if(!sessionStorage.getItem('X-Access-Token')) {
      showMessage('您还未登录，登录解锁更多功能！', 'info');
      return;
    }
  }
  return VueRouterPush.call(this, to).catch(err=> err)
}

const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err=>err)
}
const routes = [
  {
    path: "/",
    name: "home",
    component: ()=>import('@/views/Home.vue'),
  },{
    path: '/web3/module',
    name: 'module',
    component: ()=>import('@/views/components/secondaryModule.vue'),
  },{
    path: '/web3/moduleDetail',
    name: 'module',
    component: ()=>import('@/views/SecondDetail.vue'),
  },{
    path: "/login",
    name: "login",
    component: ()=>import('@/views/login/index.vue'),
  },{
    path: "/register",
    name: "register",
    component: ()=>import('@/views/login/register.vue'),
  },{
    path: "/getPassword",
    name: "getPassword",
    component: ()=>import('@/views/login/getPassword.vue'),
  }, {
    path: '/editPassword',
    name: 'editPassword',
    component: ()=> import('@/views/login/editPassword.vue')
  },{
    path: '/userCenter',
    name: "userCenter",
    component:()=>import('@/views/UserCenter.vue')
  }, {
    path: '/manage/store',
    name: 'systemManage',
    meta: {

    },
    component: ()=> import('@/views/SystemManage.vue')
  }, {
    path: '/test',
    name: 'test',
    component: ()=> import('@/views/Policy.vue')
  }, {
    path: '/:catchAll(.*)*',
    name: '404',
    component: ()=> import('@/views/NotFound.vue')
  }
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next)=>{
  const arrPath = ['/', '/?moduleTitle=首页','/login','/register', '/getPassword']
  if(!sessionStorage.getItem('X-Access-Token') && !arrPath.includes(to.path)) {
    next('/')
    return;
  }
  const rolesList = JSON.parse(sessionStorage.getItem('rolesList'))
  if((!rolesList || (!rolesList.includes('admin')) && !rolesList.includes('depart')) && to.path === '/manage/store') {
    next('/notFound');
    return;
  }
  next()
})
export default router;
